import { GET_CHANGELOG_DATA, PUSH_CHANGELOG_DATA } from './changelogType';

const initialState = {
  list: [],
  next: false,
};

const changelogReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHANGELOG_DATA:
      return {
        list: action.payload.list,
        next: action.payload.next,
      };
    case PUSH_CHANGELOG_DATA:
      return {
        list: [...state.list, ...action.payload.list],
        next: action.payload.next,
      };
    default:
      return { ...state };
  }
};

export default changelogReducer;
